import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-unsubscribe-reminder',
  templateUrl: './unsubscribe-reminder.component.html',
  styleUrl: './unsubscribe-reminder.component.scss'
})
export class UnsubscribeReminderComponent {
  middleContent: any;
  parameterobj: any;
  userToken: any;
  showThankyou: boolean=false;
  isUnsubscribed: boolean=false;

  constructor(
    private cmsService: CmsService,private activatedRoute:ActivatedRoute,public userInfoService:UserInfoService,
    private cdr:ChangeDetectorRef, protected config: OccConfig
  ) {
  }

  ngAfterViewInit(){
    this.cmsService.getComponentData('unsubscribeParagraphComponent').subscribe(data => {
      this.middleContent = data;
      this.cdr.detectChanges();
    })
  }

  ngOnInit(){
    this.activatedRoute.queryParams.subscribe(res => { 
      this.parameterobj=res;
      this.userToken  = this.parameterobj.code;
      this.checkIfUnsubscribed(this.userToken)
    });
    this.showThankyou =false;
  }

  checkIfUnsubscribed(userToken: any) {
    this.userInfoService.checkIfUnsubscribed(userToken).subscribe((data:any) => {
      this.isUnsubscribed=data;
    })
  }
  
  unsubscribeReminder(){
    this.userInfoService.unsubscribeReminder(this.userToken).subscribe((data:any) => {
      this.showThankyou =true;
      this.cdr.detectChanges();
    })
  }

}
